<i18n>
{
	"en": {
		"documents": "Documents",
		"references": "References",
		"referencesPlaceholder": "Enter reference texts here",
		"uploadDocuments": "Upload Documents"
	},

	"no": {
		"documents": "Dokumenter",
		"references": "Referanser",
		"referencesPlaceholder": "Skriv inn referansetekster her",
		"uploadDocuments": "Last opp dokumenter"
	}
}
</i18n>

<template>
	<div>

		<t-form-group :title="$t('references')" style="grid-column: 1/3;">
			<t-text-area :placeholder="$t('referencesPlaceholder')"/>
		</t-form-group>

		<t-form-group :title="$t('documents')">
			<t-button
				:value="$t('uploadDocuments')"
				iconBefore="import"
				iconType="bp"
				width="auto"
			/>
		</t-form-group>
		<div style="grid-column: 1/5;">
			<t-pane
				height="calc(100% - 48px)"
				border="default"
				background="tint2"
				borderRadius="5px"
				class="cargo-pane"
			/>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		trip: Object,
	},
};
</script>

<style>

</style>
